export default "__VITE_ASSET__BTcxN75a__"